function getActiveCallsViewModel(currentQueueModel) {
  return {
    pendingCalls: currentQueueModel.statistics.pending,
    pausedCalls: currentQueueModel.statistics.paused,
    totalCalls:
      currentQueueModel.statistics.pending +
      currentQueueModel.statistics.paused,
    concurrencyLimit: currentQueueModel.callConcurrency.concurrencyLimit ?? 3,
    concurrentCalls: currentQueueModel.callConcurrency.concurrentCalls,
  };
}

export { getActiveCallsViewModel };
